import React, { useState } from "react";
import styles from "./index.module.css";

const faqData = [
  {
    id: 1,
    question: "Q1. Where can I find the certificate number?",
    answer: "The certificate number is printed on the bottom or top section of the certificate near the QR code."
  },
  {
    id: 2,
    question: "Q2. What does “Valid Certificate” mean?",
    answer: "It means the certificate is officially issued by IBS and has not been cancelled or replaced."
  },
  {
    id: 3,
    question: "Q3. What if the certificate is cancelled or replaced?",
    answer: "The system will clearly indicate if the certificate has been cancelled or replaced and provide the correct reference."
  },
  {
    id: 4,
    question: "Q4. Who can I contact for verification support?",
    answer: `Please contact:
            📧 verify@ibs.org.pg
            ☎ +675 7411 4100
            `
  }
];

const FAQ = () => {
  const [activeId, setActiveId] = useState(null);

  const toggleFAQ = (id) => {
    setActiveId(prev => (prev === id ? null : id));
  };

  return (
    <div className={styles.faqContainer}>
      <h2 className={styles.title}>Certificate Verification – Help (FAQ)</h2>
      {faqData.map((item) => (
        <div key={item.id} className={styles.faqItem}>

          <div
            className={styles.question}
            onClick={() => toggleFAQ(item.id)}
          >
            <span>{item.question}</span>
            <span
              className={`${styles.arrow} ${activeId === item.id ? styles.rotate : ""
                }`}
            >
              ▼
            </span>
          </div>

          {activeId === item.id && (
            <div className={styles.answer} style={{ whiteSpace: "pre-line" }}>
              {item.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQ;